module.exports = __webpack_public_path__ + "img/resumeSuc.f52422b9.png";